let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hB099"), load("9CDY0"), load("6vzdH"), load("joJy8"), load("aHE9G"), load("lgm1i")]).then(() => parcelRequire('04Nru'));